import { delay } from "common/promises";
export class WatchVideoPlaying {
    constructor(video) {
        this.state = "playing";
        this.video = video;
        this.onWaiting = this.onWaiting.bind(this);
        this.onPlaying = this.onPlaying.bind(this);
    }
    async watch() {
        console.log("watch the 360 video playing");
        $(this.video).on("waiting", this.onWaiting);
        $(this.video).on("playing", this.onPlaying);
        $(this.video).one("ended", () => {
            this.hidePleaseWait();
            $(this.video).off("waiting", this.onWaiting);
            $(this.video).off("playing", this.onPlaying);
        });
        this.watchPlaying();
        this.state = "finished";
    }
    onWaiting() {
        this.showPleaseWait();
    }
    onPlaying() {
        this.hidePleaseWait();
    }
    async watchPlaying() {
        while (true) {
            await delay(10);
            if (this.state === "show-popup") {
                const stopped = this.checkStopped();
                if (!stopped) {
                    this.hidePleaseWait();
                }
            }
            if (this.state === "finished") {
                return;
            }
        }
    }
    async checkStopped() {
        const prevTime = this.video.currentTime;
        await delay(100);
        return prevTime === this.video.currentTime;
    }
    async showingPopup() {
        const prevTime = this.video.currentTime;
        while (true) {
            await delay(1000 / 30);
            if (prevTime < this.video.currentTime) {
                this.hidePleaseWait();
                return "playing";
            }
        }
    }
    showPleaseWait() {
        this.state = "show-popup";
        $("jh-360-video-loading-paused").attr("show", "");
        console.log("show please wait");
    }
    hidePleaseWait() {
        this.state = "playing";
        $("jh-360-video-loading-paused").removeAttr("show");
        console.log("hide please wait");
    }
}
//# sourceMappingURL=watchVideoPlaying.js.map